export default __webpack_public_path__ + "export-icon-white.svg";